import { render, staticRenderFns } from "./ExternalLinkIcon.vue?vue&type=template&id=3126d0d1"
import script from "./ExternalLinkIcon.vue?vue&type=script&lang=js"
export * from "./ExternalLinkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports